import React, { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { QUANTITY_OPTIONS } from "@/lib/site";

export const QuantityPicker = ({ value, onChange, testid, options = QUANTITY_OPTIONS }) => {
  const isPreset = options.includes(value);
  const [custom, setCustom] = useState(isPreset ? "" : value || "");
  const selectValue = isPreset ? value : "ozel";

  return (
    <div className="flex items-center gap-2">
      <Select
        value={selectValue}
        onValueChange={(v) => {
          if (v === "ozel") onChange(custom || "Özel miktar");
          else onChange(v);
        }}
      >
        <SelectTrigger
          data-testid={testid}
          className="h-11 w-[112px] rounded-sm border-copper/30 bg-stone font-mono text-sm text-cream"
        >
          <SelectValue placeholder="Miktar" />
        </SelectTrigger>
        <SelectContent className="border-copper/30 bg-stone-light font-mono text-cream">
          {options.map((o) => (
            <SelectItem key={o} value={o}>
              {o}
            </SelectItem>
          ))}
          <SelectItem value="ozel">Özel miktar</SelectItem>
        </SelectContent>
      </Select>
      {selectValue === "ozel" && (
        <Input
          data-testid={testid ? `${testid}-custom` : undefined}
          value={custom}
          onChange={(e) => {
            setCustom(e.target.value);
            onChange(e.target.value);
          }}
          placeholder="örn. 3 kg"
          className="h-11 w-24 rounded-sm border-copper/30 bg-stone font-mono text-sm text-cream"
        />
      )}
    </div>
  );
};

export default QuantityPicker;
